/*
 * Product · Comparison: the button scrolls smoothly to an on-page anchor
 * (Replo's "scroll to hashmark", offset 0, URL left unchanged). Links to other
 * pages, or anchors that are not on the page, navigate normally.
 */
(function () {
  if (window.pdpScrollLinkInit) return;
  window.pdpScrollLinkInit = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-pdp-scroll-link]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;

    var target = document.getElementById(decodeURIComponent(href.slice(1)));
    if (!target) return;

    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    if (target.hasAttribute('tabindex') || /^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
      target.focus({ preventScroll: true });
    }
  });
})();
